export const publishUpdate = (type, value) => {
  return { type: `NOTIFY_${type}`, value: value };
};

export default publishUpdate;
